<template>
  <div>
    <Header 
      @switchlanguage="switchLang"/>  
    <div class="wrapper backgroundhome">
      <p class="mobiletext1">{{ $t("pesquisa") }}</p>
      <OptionSelector 
        class="smallselector"
        @setOption="setOption" 
        :options="options" />
      <div class="btnwrp">
        <CalendarButton 
          @click="$emit('showpicker')"/>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import Header from '@/components/header.vue';
import OptionSelector from '@/components/optionSelector.vue';
import CalendarButton from "@/components/buttons/showCalendarButton.vue";
import { useMenuStore } from "@/stores/menu.ts";


export default {
  name: 'OptionSelectorView',
  emits:["showpicker","setOption"],
  components:{
    Header,
    OptionSelector,
    CalendarButton
  },
  setup(){
    const menuStore = useMenuStore();
    const options = computed(() => menuStore.menuItems);

    return {
      options
    }
  },
  methods:{
    switchLang(lang){
      this.$i18n.locale = lang;
    },
    setOption(option){
      this.$emit("setOption",option);
    }
  }
}
</script>

<style scoped>
.btnwrp{
  margin-top: 50px;
  display: flex;
  justify-content: center;
}

.gridwrapper {
  grid-column-gap: 12px;
  grid-row-gap: 12px;
  padding-top: 20px;
}

.backgroundhome {
  background-color:#f9f7f7;
  height: 100vh;
}

.wrapper {
  padding-left: 5%;
  padding-right: 5%;
}

.mobiletext1 {
    display: block;
    text-align: center;
    font-family: 'Montserrat';
    font-size: 19px;
    margin-bottom: 3px;
    margin-top: 5px;
}







</style>